import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { SessionContext } from "@/providers";
import { SocialCoachSession } from "@/services/bedrock";

type LegacyRedirectProps = RouteComponentProps<{ [key: string]: string }> & {
  getTo: (
    session: SocialCoachSession | undefined,
    routeProps: RouteComponentProps<{ [key: string]: string }>
  ) => string;
};

export const LegacyRedirectRoute: React.FC<LegacyRedirectProps> = ({ getTo, ...routeProps }) => {
  return (
    <SessionContext.Consumer>
      {({ session, loading }) => {
        if (loading) {
          return <Loader active size="large" />;
        }

        const to = getTo(session, routeProps);
        return <Redirect exact to={to} />;
      }}
    </SessionContext.Consumer>
  );
};
